var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { action, makeObservable, observable } from 'mobx';
import { pushGaData } from '../../common';
export default class SectionStore {
    constructor(rootStore, props) {
        Object.defineProperty(this, "section", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "openSection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setOpenSection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newSection) => {
                this.openSection = newSection;
            }
        });
        Object.defineProperty(this, "setSection", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (newSection) => {
                const { environmentStore: { app }, externalCallbackStore, ssoStore, cartStore, } = this.rootStore;
                externalCallbackStore.onHeaderSectionChange(newSection);
                if (this.section === 'sso' && newSection !== 'sso') {
                    this.section = newSection;
                    ssoStore.resetLoginCallbackState();
                    if (app === 'itb' && window.location.search.includes('login')) {
                        return;
                    }
                    ssoStore.setLoginOptions(null);
                }
                if (newSection === 'cart') {
                    cartStore.getCart();
                }
                this.section = newSection;
            }
        });
        Object.defineProperty(this, "setSectionAndPushGa", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (openSection, previousOpenSection) => {
                this.setSection(openSection);
                if (openSection === 'nav' && window.innerWidth < 1000) {
                    pushGaData({ eventAction: 'Header Menu Open', eventLabel: 'Open' });
                }
                if (previousOpenSection === 'notifications') {
                    pushGaData({ eventAction: 'Notification', eventLabel: 'Notification - close' });
                }
                if (openSection === 'notifications') {
                    pushGaData({ eventAction: 'Notification', eventLabel: 'Notification - open' });
                }
                if (openSection === 'search') {
                    pushGaData({ eventAction: 'Search Open', eventLabel: 'Open' });
                }
                if (openSection === 'cart') {
                    pushGaData({ eventAction: 'Cart', eventLabel: 'Open' });
                }
                if (openSection === 'sso') {
                    pushGaData({ eventCategory: 'SSO', eventAction: 'Login', eventLabel: 'Button - Login' });
                }
            }
        });
        makeObservable(this);
        this.rootStore = rootStore;
        this.setOpenSection(props.openSection);
    }
}
__decorate([
    observable
], SectionStore.prototype, "section", void 0);
__decorate([
    observable
], SectionStore.prototype, "openSection", void 0);
__decorate([
    action
], SectionStore.prototype, "setOpenSection", void 0);
__decorate([
    action
], SectionStore.prototype, "setSection", void 0);
//# sourceMappingURL=SectionStore.js.map